<template>
	<div class="Mobiles">
		<Mobileheader routeNmae="/home" v-if="$store.state.isMobile !== 3" />
		<div class="introduction">
			<!-- <img class="back1" src="@/assets/mobileStatic/homelcback.png"> -->
			<img class="imgBack" src="@/assets/mobileStatic/home.jpg">
			<!-- <img class="title" src="@/assets/mobileStatic/title.png"> -->
			<div class="headerTabs">
				<el-tabs class="tabs" v-model="tabIndex" stretch @tab-click="tabClick">
					<el-tab-pane label="公司简介" name="0">
						<div class="gsjjs">

							<div class="language" @click="textEn = !textEn">
								<span v-if="textEn">英文EN</span>
								<span v-else>中文</span>
							</div>
							<template v-if="textEn">
								<!-- <div class="span">
									园测信息科技股份有限公司成立于1995年，是国家高新技术企业、江苏省双软认证企业，中国地理信息产业前50强，目前位列第34位。公司具备甲级测绘资质，通过CMMI5五级软件成熟度认证、ISO9001质量管理体系认证和ISO27001信息安全管理体系认证，累计获得国家和省部级以上科技进步奖{{
										showData.awards }}余项、软件产品及著作权{{ showData.copyrights }}余项。
								</div>
								<div class="span">
									公司现有员工逾1000名，其中本科以上学历占比超90%，研究生占比40%，设有城市空间智能感知与时空大数据融合创新中心、江苏省地理人工智能工程技术研究中心、苏州市测绘地理信息工程技术研究中心、苏州工业园区博士后科研工作站、武汉大学研究生工作站等。
								</div>
								<div class="span">
									公司成立28年来，全程参与了苏州工业园区“一张蓝图”的绘制与实现，是园区智慧城市建设的长效驱动力，形成了以地理信息技术为核心的，从基础数据采集、大数据分析到智慧化应用的全链条、全生命周期的智慧城市解决方案，涵盖智慧交通、智慧城管、智慧规划、智慧国土、智慧乡镇等各个领域，并在江苏南京、徐州、宿迁、南通、扬州，安徽合肥、滁州，广西钦州，浙江嘉善，重庆，北京等地设立分子公司，将“园区经验”输出全国。
								</div> -->
								<div class="span" v-html="showData.introduction">
									<!-- 园测信科以智慧信息构建更美好的城市生活为使命，打造智慧开发区和新型城镇建设领先品牌。 -->
								</div>
							</template>
							<template v-else>
								<div class="span">
									Yuance Information Technology Co., Ltd. was established in 1995. It is a national
									high-tech
									enterprise and a dual software certification enterprise in Jiangsu Province. It is one
									of the top 50
									in China's geographic information industry and currently ranks 34th. The company has a
									Class A
									surveying and mapping qualification, and has passed CMMI Level 5 software maturity
									certification,
									ISO9001 quality management system certification, and ISO27001 information security
									management system
									certification. It has accumulated more than {{ showData.awards }} national and
									provincial level and above
									scientific
									and technological progress awards, and more than {{ showData.copyrights }} software
									products and
									copyrights.
								</div>
								<div class="span">
									The company currently has over 1000 employees, with over 90% holding a bachelor's degree
									or above
									and 40% holding a graduate degree. It has established the Urban Spatial Intelligent
									Perception and
									Spatiotemporal Big Data Integration Innovation Center, Jiangsu Provincial Geographic
									Artificial
									Intelligence Engineering Technology Research Center, Suzhou Surveying and Mapping
									Geographic
									Information Engineering Technology Research Center, Suzhou Industrial Park Postdoctoral
									Research
									Workstation, and Wuhan University Graduate Workstation.
								</div>
								<div class="span">
									Since its establishment for 28 years, the company has participated in the drafting and
									implementation of the "One Unified Map" for Suzhou Industrial Park, which is a long-term
									driving
									force for the construction of smart cities in the park. It has formed a smart city
									solution with
									geographic information technology as the core, covering various fields such as smart
									transportation,
									city management, city planning, smart land, smart towns, and other fields, from basic
									data
									collection, big data analysis to intelligent application, with a full chain and full
									lifecycle, And
									establish subsidiary companies in Nanjing, Jiangsu, Xuzhou, Suqian, Nantong, Yangzhou,
									Hefei,
									Chuzhou, Qinzhou, Jiashan, Chongqing, Beijing, and other places to export the "Suzhou
									Industrial
									Park Experience" to the whole country.
								</div>
								<div class="span">
									The company's mission is to build a better urban life with intelligent information, and
									to create a
									leading brand for intelligent development zones and new urban construction.
								</div>
							</template>
							<div class="items">
								<div class="item">


									<div class="name">
										<img src="@/assets/mobileStatic/canye.png">
										<div class="flexsp" v-if="textEn">{{ showData.geographicTitle }}<div>
												<span>{{ showData.geographic }}</span><span>强</span>
											</div>
										</div>
										<div v-else>China Geographic Information Industry Corporation
											Top{{ showData.geographic }}</div>
									</div>

								</div>
								<div class="item">
									<div class="name">
										<img src="@/assets/mobileStatic/canye.png">
										<div class="flexsp" v-if="textEn">{{ showData.awardsTitle }}<div>
												<span>{{ showData.awards }}</span><span>余项</span>
											</div>
										</div>
										<div v-else>National and Provincial Awards {{ showData.awards }}+</div>
									</div>


								</div>
								<div class="item">

									<div class="name">
										<img src="@/assets/mobileStatic/canye.png">
										<div class="flexsp" v-if="textEn">{{ showData.copyrightsTitle }}<div>
												<span>{{ showData.copyrights }}</span><span>余项</span>
											</div>
										</div>
										<div v-else>Patents and Copyrights {{ showData.copyrights }}+</div>
									</div>

								</div>
							</div>
						</div>
						<div class="label">
							<img class="labelImg" src="@/assets/mobileStatic/labelIcon.png" mode="">
							<span v-if="textEn">发展历程</span>
							<span v-else>Milestones</span>
						</div>
						<div class="course">
							<div  v-for="(item, index) in developHistoryList" :key="index">
								<div class="item"  v-if="index % 2 === 0">
									<template>
										<div class="time">
											<img class="timeIcon" src="@/assets/mobileStatic/timeline.png" mode="">
											<span class="timespan">{{ item.startTime }}-{{ item.endTime }}<span
													v-if="textEn">年</span> </span>
										</div>
										<div class="conts">
											<img class="img" src="@/assets/mobileStatic/falcimg.png" mode="">
											<div class="spans" v-if="textEn">
												&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.content }}
												<!-- 成立苏州工业园区测绘有限责任公司，为园区规划建设局下属事业单位，增挂“园区测绘中心”牌子。公司是苏州工业园区首批建设者，全过程亲历者、见证者和实践者。借鉴新加坡的先进经验，秉持一张蓝图绘到底的理念，成立初期即建立了“多测合一”测绘跟踪服务体系，致力于为园区高标准的城市规划、建设和管理提供数字化技术支撑。 -->
											</div>
											<div class="spans" v-else>
												We were established as a business unit under the Planning and Construction
												Bureau of
												Suzhou Industrial Park, and the brand of "Surveying and Mapping Centre of
												Suzhou
												Industrial Park" was added. The company is one of the first batch of
												builders in
												SIP, and it has experienced, witnessed and practiced the whole process.
												Drawing
												on
												Singapore's advanced experience and adhering to the concept of drawing a
												blueprint
												to the end, the company established a "multi-measurement and mapping
												tracking
												service system" at the early stage of its establishment, and is committed to
												providing digital technical support for the high-standard urban planning,
												construction and management of the park.
											</div>
										</div>
									</template>
								</div>
								<div class="item" v-else>
									<template >
										<div class="time">

											<span class="timespan">{{ item.startTime }}-{{ item.endTime }}<span
													v-if="textEn">年</span> </span>
											<img class="timeIcon" src="@/assets/mobileStatic/timeline2.png" mode="">
										</div>
										<div class="conts">
											<div class="spans" v-if="textEn">
												&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item.content }}
												<!-- 公司获得甲级测绘资质，取得IS09001质量标准体系，开始为园区城市信息化建设提供专题应用系统服务，辅助决策和管理。公司在城市空间资源管理上适度超前发展，为统一城市空间基准，完成了园区首级GPS网及固定基准站建设，建立了苏州CORS系统，实现苏州大市域各类地理数据的厘米级定位服务，并持续沉淀空间数据。 -->
											</div>
											<div class="spans" v-else>
												The company obtained Class A surveying and mapping qualification and IS09001
												quality
												standard system, and started to provide thematic application system services
												for
												urban information construction in the park to assist decision-making and
												management.
												The company has developed moderately ahead of its time in urban spatial
												resource
												management. In order to unify urban spatial benchmarks, the company has
												completed
												the construction of the park's first-level GPS network and fixed benchmark
												stations,
												established the Suzhou CORS system, realised centimetre-level positioning
												services
												for all kinds of geographic data in Suzhou's large city area, and continued
												to
												precipitate spatial data.
											</div>
											<img class="img" src="@/assets/mobileStatic/falcimg.png" mode="">

										</div>
									</template>
								</div>
							</div>
							<!-- <div class="item">
								<div class="time">
									<img class="timeIcon" src="@/assets/mobileStatic/timeline.png" mode="">
									<span class="timespan">2005-2009<span v-if="textEn">年</span> </span>
								</div>
								<div class="conts">

									<img class="img" src="@/assets/mobileStatic/falcimg.png" mode="">
									<div class="spans" v-if="textEn">
										为更好地适应市场经济的发展、激发活力，公司划归国资委管理，全面实施现代化公司治理。同时为深化国企改革，成立了全资信息化子公司格网信息科技，并设立了苏宿园区分公司对外输出园区经验。期间挂牌成立了博士后科研工作站和多家高校学生实习基地，多种信息系统平台的建设取得重要突破，实现多源信息的跨部门共享，园区管线信息系统等多个项目获中国地理信息产业协会优秀工程奖。
									</div>
									<div class="spans" v-else>
										In order to better adapt to the development of the market economy and stimulate
										vitality, the company was transferred to the management of the State-owned Assets
										Supervision and Administration Commission (SASAC), and modernised corporate
										governance was fully implemented. At the same time, in order to deepen the reform of
										state-owned enterprises, the company set up a wholly-owned information technology
										subsidiary, Grid Information Technology, and set up a branch office of Suzhu Park to
										export the experience of the park. During this period, the company has set up
										post-doctoral research stations and internship bases for students of many
										universities, made important breakthroughs in the construction of various
										information system platforms, realised the cross-sectoral sharing of multi-source
										information, and won the China Geoinformation Industry Association's Outstanding
										Project Award for many projects, such as the pipeline information system in the
										park.
									</div>
								</div>

							</div>
							<div class="item">
								<div class="time">

									<span class="timespan">2010-2017<span v-if="textEn">年</span></span>
									<img class="timeIcon" src="@/assets/mobileStatic/timeline2.png" mode="">
								</div>

								<div class="conts">
									<div class="spans" v-if="textEn">
										公司实现了向平台化、智慧化方向的发展。以地理信息技术为核心，业务涵盖了从基础数据采集、数据治理及分析到智慧化应用的全链条、全生命周期的智慧城市整体解决方案。期间成立滁州圆信公司、江苏圆信公司、中马钦州数字城市公司，成为武汉大学首个省外研究生工作站，当选中国开发区协会智慧开发区建设专业委员会理事长单位，多个项目荣获中国地理信息产业优秀工程奖，公司经营业绩实现逐年增长。
									</div>
									<div class="spans" v-else>
										The company has realised the development towards platform and intelligence. With
										geographic information technology as the core, the business covers the whole chain
										and life cycle of smart city overall solutions from basic data collection, data
										governance and analysis to intelligent applications. During the period, Chuzhou
										branch offices, Jiangsu branch offices, China-Malaysia Qinzhou Digital City offices
										were set up. Also, we became the first out-of-province postgraduate workstation of
										Wuhan University, were elected as the chairman of the China Development Zone
										Association's Intelligent Development Zone Construction Professional Committee, and
										a number of projects were awarded the Outstanding Engineering Award of China's
										Geographic Information Industry. The company's business performance achieved
										year-on-year growth.
									</div>
									<img class="img" src="@/assets/mobileStatic/falcimg.png" mode="">

								</div>
							</div>
							<div class="item">
								<div class="time">
									<img class="timeIcon" src="@/assets/mobileStatic/timeline.png" mode="">
									<span class="timespan">2018-2022<span v-if="textEn">年</span></span>
								</div>

								<div class="conts">

									<img class="img" src="@/assets/mobileStatic/falcimg.png" mode="">
									<div class="spans" v-if="textEn">
										公司完成混合所有制改革，企业活力进一步释放。明确“客户至上、贡献为荣、求真务实、合作共赢”的价值观。在宏观环境不利的情况下不断补链、强链，先后与重庆九龙坡大数据发展局、江苏海鸿投资控股集团、北京临空经济区、九江市自然资源局等多个合作伙伴签署战略协议并落地合资子公司。收购苏州高新区测绘股权，设立圆信云网、新建元岩土等专业子公司，加强在基础研发上的投入，公司在智慧城市领域实现进一步的纵深发展，至2022年连续八年入围中国地理信息产业百强企业。2022年11月，公司历时5年打造的Mapmost数字孪生底座平台正式发布，为数字孪生应用构建提供了有力支持，助力打造公司标杆项目。
									</div>
									<div class="spans" v-else>
										The company completed the reform of mixed ownership system, which further released
										the vitality of the enterprise. The company has clearly defined the values of
										"customer first, contribution pride, truthfulness and pragmatism, cooperation and
										win-win". Despite the unfavourable macro environment, the company continued to make
										up the chain and strengthen the chain, and signed strategic agreements and set up
										joint venture subsidiaries with a number of partners, such as Chongqing Jiulongpo
										Big Data Development Bureau, Jiangsu Haihong Investment and Holding Group, Beijing
										LinKong Economic Zone, and Natural Resources Bureau of Jiujiang City. Acquisition of
										Suzhou High-tech Zone mapping stake, the establishment of round letter cloud
										network, new yuan geotechnical and other professional subsidiaries, to strengthen
										the investment in basic research and development, the company in the field of smart
										city to achieve further in-depth development, to 2022 for eight consecutive years in
										China's geographic information industry, the top 100 enterprises. 2022, November,
										the company took five years to build the Mapmost Digital Twin base platform was
										officially released, for digital Twin application construction provides strong
										support, help to build the company's benchmark project.
									</div>

								</div>
							</div>
							<div class="item">
								<div class="time">

									<span class="timespan" v-if="textEn">2023年-至今</span><span v-else
										class="timespan">2023-</span>
									<img class="timeIcon" src="@/assets/mobileStatic/timeline2.png" mode="">
								</div>

								<div class="conts">
									<div class="spans" v-if="textEn">
										公司实现了向平台化、智慧化方向的发展。以地理信息技术为核心，业务涵盖了从基础数据采集、数据治理及分析到智慧化应用的全链条、全生命周期的智慧城市整体解决方案。期间成立滁州圆信公司、江苏圆信公司、中马钦州数字城市公司，成为武汉大学首个省外研究生工作站，当选中国开发区协会智慧开发区建设专业委员会理事长单位，多个项目荣获中国地理信息产业优秀工程奖，公司经营业绩实现逐年增长。
									</div>
									<div class="spans" v-else>
										The company completed the shareholding reform, the development of a new stage, and
										formally changed its name to "Garden Measurement Information Technology Co., Ltd.",
										the future will rely on the advanced level of technology, sustained focus on
										research and development, excellent product quality and service quality to continue
										to provide services to customers.
									</div>
									<img class="img" src="@/assets/mobileStatic/falcimg.png" mode="">

								</div>
							</div> -->
						</div>
						<div class="label">
							<img class="labelImg" src="@/assets/mobileStatic/labelIcon.png" mode="">
							<span v-if="textEn">业务架构</span>
							<span v-else>Business Infrastructure</span>
						</div>
						<div class="architecture" v-if="textEn">
							<img src="@/assets/mobileStatic/yw1.jpg">
							<img src="@/assets/mobileStatic/yw2.jpg">
						</div>
						<div class="architecture" v-else>
							<img src="@/assets/mobileStatic/yw1En.jpg">
							<img src="@/assets/mobileStatic/yw2En.jpg">
						</div>
						<div class="label">
							<img class="labelImg" src="@/assets/mobileStatic/labelIcon.png" mode="">
							<span v-if="textEn">行业专题活动</span>
							<span v-else>FEATURED ACTIVITIES</span>
						</div>
						<div v-show="SolutionCityList.length > 0" class="tabsauto">
							<el-tabs v-model="activeIndex" stretch>
								<el-tab-pane v-for="(item, index) in SolutionCityList" :label="item.titleMain"
									:name="index + ''">
									<div class="tabcont">
										<img class="imgSrc" :src="item.imgUrl" />
										<div v-html="SolutionCityList[activeIndex].titleAssistant"></div>
										<div class="btnMore" v-if="item.link">
											<a :href="SolutionCityList[activeIndex].link" target="_blank">
												<span>了解更多</span>
												<img src="@/assets/img/ljgd.png" alt="">
											</a>
										</div>
									</div>

								</el-tab-pane>
							</el-tabs>
						</div>

						<div class="tabsConts">
							<!-- <div v-html="item.titleAssistant"></div> -->
						</div>
					</el-tab-pane>
					<el-tab-pane label="宣传册" name="1">
						<!-- <Pdf></Pdf> -->
						<img style="width: 100%;" src="pdf/xcc.jpg" alt="">
					</el-tab-pane>
					<el-tab-pane label="宣传视频" name="2">
            <video width="100%" poster="https://www.cqdpark.com/card-api/file/ycxxofficial/xcc.png" controls src="https://www.cqdpark.com/card-api/file/ycxxofficial/ycxk.mp4" preload></video>
						<!-- <video-player class="video-player vjs-custom-skin" ref="vueMiniPlayer" :options="playerOptions"
							@pause="onPlayerPause($event)"></video-player> -->
						<!-- <button class="moveVideo">观看更多视频</button> -->
					</el-tab-pane>

				</el-tabs>
			</div>

		</div>

	</div>
</template>

<script>
import Pdf from "@/components/Pdf.vue"
import cfg from "@/utils/config.js"
import { getCommonDataList } from '@/api/news.js'
import { banner } from "@/api/public"
import { getCompanyList, getDevelopHistoryList } from "@/api/home"
export default {
	components: {
		Pdf,
	},
	data() {

		return {
			developHistoryList: [],//发展历程数据
			companyBriefIntroductionData: [],//公司简介
			textEn: true,
			tabIndex: '0',
			SolutionCityList: [],
			activeIndex: 0,
			showData: {
				introduction: '',
				moreName: '',
				geographic: '',
				awards: '',
				copyrights: '',
				geographicTitle: '',
				awardsTitle: '',
				copyrightsTitle: '',
				url: '',
			},
			playerOptions: {

				playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度

				autoplay: false, //如果true,浏览器准备好时开始回放。

				muted: true, // 默认情况下将会消除任何音频。

				loop: false, // 导致视频一结束就重新开始。

				preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）

				language: 'zh-CN',

				aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）

				fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。

				sources: [{

					type: "video/mp4",

					// src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4" //url地址
					src: cfg.fileUrl + '/ycxxFileUrl/mp4/ycxk.mp4'

				}],

        poster: "https://www.cqdpark.com/card-api/file/ycxxofficial/xcc.png", //你的封面地址

				// width: document.documentElement.clientWidth,

				notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。

				controlBar: {

					timeDivider: true,

					durationDisplay: true,

					remainingTimeDisplay: false,

					fullscreenToggle: true  //全屏按钮

				}

			},
		};
	},
	mounted() {
		getCommonDataList({ commonData: 'company_brief_introduction', isRelease: this.$store.state.editStatus }).then(res => {
			let arr = JSON.parse(JSON.stringify(res.data));
			arr.map(item => {
				if (item.keyName == '公司简介') {
					this.showData.introduction = item.keyValue
				} else if (item.keyName == '查看更多') {
					this.showData.moreName = item.keyValue
					this.showData.url = item.url
				} else if (item.typeName == '中国地理信息产业') {
					this.showData.geographic = item.keyValue
					this.showData.geographicTitle = item.keyName
				} else if (item.typeName == '国家和省部奖项') {
					this.showData.awards = item.keyValue
					this.showData.awardsTitle = item.keyName
				} else if (item.typeName == '专利及著作权') {
					this.showData.copyrights = item.keyValue
					this.showData.copyrightsTitle = item.keyName
				}
			})
		})
		banner({ isRelease: this.$store.state.editStatus, type: 13 }).then(res => { debugger; this.SolutionCityList = res.data; })
		this.getDevelopHistoryList();
		// this.getcompanyBriefIntroduction()

	},
	methods: {
		  //公司简介
	// 	  getcompanyBriefIntroduction () {
    //   getCommonDataList({ commonData: 'company_brief_introduction', isRelease: this.$store.state.editStatus }).then(res => {
    //     this.companyBriefIntroductionData = JSON.parse(JSON.stringify(res.data));
    //   })
    // },
		getDevelopHistoryList() {
			getDevelopHistoryList({ isRelease: this.$store.state.editStatus }).then(res => {
				this.developHistoryList = res.data;
			})
		},
		tabClick() {
			console.log(this.$refs.vueMiniPlayer)
			// this.$refs.vueMiniPlayer.pause()//暂停
		},
		onPlayerPause() {
		}
	}

}
</script>



<style lang="scss" scoped>
@media screen and (max-width:767px) {
	.introduction {
		background-color: #fff;
		position: relative;
		background-image: url(../../assets/mobileStatic/homelcback.png);
		height: auto;

		.imgBack {

			width: 100%;

			height: 656px;

			z-index: 1;
			display: block;
		}

		.back1 {

			width: 100%;
			height: 2084px;
			display: block;
		}

		.title {
			position: absolute;
			width: 478px;
			left: 50%;
			margin-left: -239px;
			top: 275px;
			z-index: 2;
		}

		.gsjjs {

			width: 100%;
			z-index: 2;
			padding: 0 57px;
			box-sizing: border-box;
			font-size: 28rpx;

			.language {

				color: #2D72FF;
				font-size: 28px;
				text-align: right;
				margin-bottom: 30px;
			}

			.span {
				text-indent: 2em;
				font-size: 28px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #373737;
				line-height: 40px;
			}

			.items {


				margin-top: 80px;

				.item {
					width: 100%;
					text-align: center;
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-bottom: 40px;


					.spans {
						font-size: 42px;
						font-family: Source Han Sans CN;
						font-weight: 800;
						color: #2D72FF;

						span:last-child {
							font-size: 26px;
							color: #373737;
						}
					}

					.name {
						font-size: 28px;
						color: #373737;
						display: flex;
						align-items: center;
						text-align: left;
						width: 100%;

						.flexsp {
							display: flex;
							justify-content: space-between;
							align-items: center;
							width: 100%;

							>div {
								span {
									&:first-child {
										font-size: 42px;
										font-family: Source Han Sans CN;
										font-weight: 800;
										color: #2D72FF;
									}

								}
							}
						}

						img {
							width: 44px;
							height: 44px;
							margin-right: 20px;
						}
					}
				}
			}
		}


	}

	.label {
		height: 74px;
		padding-left: 20px;
		position: relative;
		background-color: #F2F5FB;
		display: flex;
		align-items: center;
		padding-top: 20px;

		.labelImg {
			width: auto;
			height: 32px;
			position: absolute;
			z-index: 2;

		}

		span {
			font-size: 32px;
			margin-left: 20px;
			font-weight: bold;
		}
	}

	.course {

		position: relative;
		background-color: #fff;
		padding-top: 80px;

		.courseBack {
			width: 100%;
			height: 100%;
			position: absolute;
		}


		.item {

			padding: 20px 20px 20px 50px;
			box-sizing: border-box;
			position: relative;

			.time {
				.timeIcon {
					width: 303px;
					height: 20px;
					margin-right: 8px;
				}

				.timespan {
					font-size: 40px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					color: #2D72FF;

				}
			}

			.conts {
				display: flex;
				align-items: center;

				.spans {
					text-indent: 2em;
					padding-left: 20px;
					box-sizing: border-box;
					margin-top: 20px;
					font-size: 26px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #373737;
					flex-shrink: 0;
					width: 390px;
				}

				.img {
					width: 260px;
					margin-left: 20px;
				}



			}

			&:nth-child(even) {
				.time {
					.timeIcon {
						margin-left: 20px;
						// transform: rotate(180deg);
					}
				}

				.conts {

					.img {
						transform: rotate(180deg);
						margin-right: 20px;
					}
				}

			}

		}
	}

	.architecture {
		background-color: #fff;
		padding-top: 57px;

		img {
			display: block;
			width: 100%;
		}
	}

	.tabsauto {
		::v-deep .el-tabs__nav {
			width: 100%;
			overflow: hidden;
			overflow-x: auto;
		}

		.tabcont {
			padding: 20px;
			box-sizing: border-box;

			.imgSrc {
				width: 100%;
				margin-bottom: 10px;
			}

			.btnMore {
				width: 169px;
				height: 72px;
				background: #2D72FF;
				border-radius: 6px;
				margin-top: 10px;

				a {
					display: flex;
					align-items: center;
					justify-content: center;
					height: 72px;
					font-size: 24px;
					color: #fff;
					text-decoration: none;

					img {
						width: 16px;
						margin-left: 10px;
					}
				}

			}
		}

	}
}

.headerTabs {
	width: 100%;

	.moveVideo {
		background-color: #3E84FF;
		color: #fff;
		font-size: 28px;
		text-align: center;
		line-height: 60px;
		border: none;
		width: 300px;
		display: block;
		margin: 0 auto;
		margin-top: 50px;
		border-radius: 30px;
		padding: 0 20px;
	}



}</style>

